<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->

    <div class="div-center">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleTabClick"
        v-loading="loading"
        style="height: 100%"
      >
        <el-tab-pane label="完成率" name="0">
          <div class="div-top">
            <el-date-picker
              v-model="searchData.Year"
              type="year"
              value-format="yyyy"
              @change="handleSearch"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div id="completionRate" class="tab-chart-container"></div>
        </el-tab-pane>
        <el-tab-pane label="工单量" name="1">
          <div class="div-top">
            <el-date-picker
              v-model="searchData.Year"
              type="year"
              value-format="yyyy"
              @change="handleSearch"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div id="workOrderCount" class="tab-chart-container"></div>
        </el-tab-pane>
        <el-tab-pane label="问题率" name="2">
          <div class="div-top">
            <el-date-picker
              v-model="searchData.Year"
              type="year"
              value-format="yyyy"
              @change="handleSearch"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div id="problemRate" class="tab-chart-container"></div>
        </el-tab-pane>
        <el-tab-pane label="问题类型" name="3">
          <div class="div-top">
            <el-date-picker
              v-model="searchData.Year"
              type="year"
              value-format="yyyy"
              @change="handleSearch"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div id="problemType" class="tab-chart-container"></div>
        </el-tab-pane>
        <el-tab-pane label="设备类型工单量" name="4">
          <div class="div-top">
            <el-date-picker
              v-model="searchData.Year"
              type="year"
              value-format="yyyy"
              @change="handleSearch"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <div id="deviceTypeWorkOrderCount" class="tab-chart-container"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      searchData: {
        Year: '',
      },
      activeName: '0',
      loading: false,
      chartData: [],
    }
  },
  props: {},
  components: {},
  methods: {
    handleTabClick(tab) {
      this.activeName = tab.name
      this.getDataList()
      // this.renderChart();
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderAnalysis', {
          Year: this.searchData.Year,
          Type: this.activeName,
          DeviceType: this.devTreeSearch.DeviceType || '',
          BuildingId: this.devTreeSearch.BuildingId || '',
          InstallationArea: this.devTreeSearch.InstallationArea || '',
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.chartData = resJson.Data || []
            this.renderChart()
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.getDataList()
    },
    renderChart() {
      // 销毁所有echarts实例，避免重复渲染
      const chartIds = [
        'completionRate',
        'workOrderCount',
        'problemRate',
        'problemType',
        'deviceTypeWorkOrderCount',
      ]
      chartIds.forEach((id) => {
        let dom = document.getElementById(id)
        if (dom && dom.__echarts__) dom.__echarts__.dispose()
      })
      let chartId = ''
      if (this.activeName === '0') {
        chartId = 'completionRate'
      } else if (this.activeName === '1') {
        chartId = 'workOrderCount'
      } else if (this.activeName === '2') {
        chartId = 'problemRate'
      } else if (this.activeName === '3') {
        chartId = 'problemType'
      } else if (this.activeName === '4') {
        chartId = 'deviceTypeWorkOrderCount'
      }
      this.$nextTick(() => {
        let dom = document.getElementById(chartId)
        if (!dom) return
        let myChart = echarts.init(dom)
        let option = {}
        // 根据不同tab渲染不同option
        if (this.activeName === '0') {
          // 完成率
          option = {
            // title: { text: '工单完成率' },
            grid: {
              left: 60,
              top: 90,
              right: 40,
              bottom: 40,
            },
            tooltip: {},
            xAxis: {
              type: 'category',
              data: this.chartData.map((i) => i.name),
            },
            yAxis: {
              type: 'value',
              // max: 100,
              // min: 0,
              // interval: 20,
            },
            series: [
              {
                name: '完成率',
                type: 'bar',
                data: this.chartData.map((i) => i.value),
                label: {
                  show: true,
                  // position: "top",
                  formatter: function (params) {
                    return params.value === 0 ? '' : params.value + '%'
                  },
                },
                itemStyle: {
                  color: function (params) {
                    const colors = [
                      '#5470C6',
                      '#91CC75',
                      '#EE6666',
                      '#FAC858',
                      '#73C0DE',
                      '#3BA272',
                      '#FC8452',
                      '#9A60B4',
                      '#EA7CCC',
                      '#FF9F7F',
                      '#B6A2DE',
                      '#2EC7C9',
                      '#B7A2DE',
                      '#FFB980',
                      '#5AB1EF',
                    ]
                    return colors[params.dataIndex % colors.length]
                  },
                },
              },
            ],
          }
        } else if (this.activeName === '1') {
          // 工单量
          option = {
            // title: { text: "工单量" },
            tooltip: {},
            grid: {
              left: 60,
              top: 90,
              right: 40,
              bottom: 40,
            },
            xAxis: {
              type: 'category',
              data: this.chartData.map((i) => i.name),
            },
            yAxis: { type: 'value' },
            series: [
              {
                name: '工单量',
                type: 'bar',
                data: this.chartData.map((i) => i.value),
                label: {
                  show: true,
                  // position: "top",
                  formatter: function (params) {
                    return params.value === 0 ? '' : params.value
                  },
                },
                itemStyle: {
                  color: function (params) {
                    const colors = [
                      '#5470C6',
                      '#91CC75',
                      '#EE6666',
                      '#FAC858',
                      '#73C0DE',
                      '#3BA272',
                      '#FC8452',
                      '#9A60B4',
                      '#EA7CCC',
                      '#FF9F7F',
                      '#B6A2DE',
                      '#2EC7C9',
                      '#B7A2DE',
                      '#FFB980',
                      '#5AB1EF',
                    ]
                    return colors[params.dataIndex % colors.length]
                  },
                },
              },
            ],
          }
        } else if (this.activeName === '2') {
          // 问题率
          option = {
            // title: { text: "问题率" },
            tooltip: {},
            grid: {
              left: 60,
              top: 90,
              right: 40,
              bottom: 40,
            },
            xAxis: {
              type: 'category',
              data: this.chartData[0]?.value?.map((i) => i.name),
            },
            yAxis: { type: 'value' },
            legend: {
              type: 'scroll',
              width: '80%',
              data: this.chartData.map((i) => i.name),
              show: true,
              top: 30,
            },
            series: this.chartData.map((i) => ({
              name: i.name,
              type: 'bar',
              data: i.value,
              label: {
                show: true,
                // position: "top",
                formatter: function (params) {
                  return params.value === 0 ? '' : params.value + '%'
                },
              },
              stack: 'total',
            })),
          }
        } else if (this.activeName === '3') {
          // 问题类型
          option = {
            // title: { text: "问题类型分布" },
            tooltip: {},
            grid: {
              left: 60,
              top: 90,
              right: 40,
              bottom: 40,
            },
            xAxis: {
              type: 'category',
              data: this.chartData[0]?.value?.map((i) => i.name),
            },
            yAxis: { type: 'value' },
            legend: {
              type: 'scroll',
              width: '80%',
              data: this.chartData.map((i) => i.name),
              show: true,
              top: 30,
            },
            series: this.chartData.map((i) => ({
              name: i.name,
              type: 'bar',
              data: i.value,
              label: {
                show: true,
                // position: "top",
                formatter: function (params) {
                  return params.value === 0 ? '' : params.value
                },
              },
              stack: 'total',
            })),
          }
        } else if (this.activeName === '4') {
          // 设备类型工单量
          option = {
            // title: { text: "设备类型工单量" },
            tooltip: {},
            grid: {
              left: 60,
              top: 90,
              right: 40,
              bottom: 40,
            },
            xAxis: {
              type: 'category',
              data: this.chartData[0]?.value?.map((i) => i.name),
            },
            yAxis: { type: 'value' },
            legend: {
              type: 'scroll',
              width: '80%',
              data: this.chartData.map((i) => i.name),
              show: true,
              top: 30,
            },
            series: this.chartData.map((i) => ({
              name: i.name,
              type: 'bar',
              data: i.value,
              label: {
                show: true,
                // position: "top",
                formatter: function (params) {
                  return params.value === 0 ? '' : params.value
                },
              },
              stack: 'total',
            })),
          }
        }
        myChart.setOption(option)
      })
    },
  },
  mounted() {},
  created() {
    this.searchData.Year = this.$tools.timeFormat(new Date(), 'YYYY')
    this.activeName = '0'
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  // margin-top: 10px;
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .el-tabs__content {
  height: calc(100% - 50px);
  .el-tab-pane {
    height: 100%;
  }
}
.tab-chart-container {
  width: 100%;
  height: calc(100% - 37px);
}
</style>
